import Axios from "axios";
import {
  SET_MY_DAILY_ATTENDANCE_REPORT,
  UNSET_MY_DAILY_ATTENDANCE_REPORT,
} from "@/store/mutation-types";
import {
  getMyDailyAttendanceReport,
} from "@/store/api";

const state = {
  myDailyAttendanceReport: [],
};

const getters = {
  getMyDailyAttendanceReport(state) {
    return state.myDailyAttendanceReport;
  },
};

const mutations = {
  [SET_MY_DAILY_ATTENDANCE_REPORT](state, data) {
    state.myDailyAttendanceReport = data;
  },
  [UNSET_MY_DAILY_ATTENDANCE_REPORT](state) {
    state.myDailyAttendanceReport = [];
  },
};

const actions = {
  getMyDailyAttendanceReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getMyDailyAttendanceReport}`, { params: data })
        .then((response) => {
          commit(SET_MY_DAILY_ATTENDANCE_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_MY_DAILY_ATTENDANCE_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

